module.exports = __webpack_public_path__ + "img/rope.832b4ffd.svg";